<template>
  <div>
    <el-form :inline="true" :model="query" @keyup.enter.native="load">
      <el-form-item label="会计年度">
        <el-select v-model="query.year" size="small" style="width:100px" @change="onYearChange">
          <el-option v-for="y in years" :key="y" :label="y" :value="y" />
        </el-select>
      </el-form-item>
      <el-form-item label="期号">
        <el-select v-model="query.periodNo" size="small" style="width:80px" @change="load">
          <el-option v-for="n in 12" :key="n" :label="n" :value="n" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('finance:profitStatement:list')" type="primary" size="small" @click="load">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="profit-explanation">金额按对利润的影响列示：收入为正，成本费用为负；本年累计从本年度第 1 期计算至所选期。</div>
    <el-table :data="list" border v-loading="loading" :header-cell-style="headStyle" :row-class-name="rowClassName">
      <el-table-column prop="sectionName" label="报表项目" width="100" />
      <el-table-column prop="subjectCode" label="科目编码" width="140" />
      <el-table-column prop="subjectName" label="科目名称" min-width="160" />
      <el-table-column prop="amount" label="本期金额" width="140" align="right"><template slot-scope="s">{{ money(s.row.amount) }}</template></el-table-column>
      <el-table-column prop="yearAmount" label="本年累计" width="140" align="right"><template slot-scope="s">{{ money(s.row.yearAmount) }}</template></el-table-column>
    </el-table>
  </div>
</template>

<script>
import request from '../../api/request'
import auth from './financeAuth'
import periodQuery from './financePeriodQuery'

export default {
  mixins: [auth, periodQuery],
  data() { return { list: [] } },
  created() { this.loadLedgerYears(true) },
  methods: {
    rowClassName({ row }) { return row.rowType === 'total' ? 'profit-total-row' : '' },
    load() {
      if (!this.query.year || !this.query.periodNo) { this.$message.warning('请选择会计年度和期号'); return }
      this.loading = true
      request.get('/finance/profitStatement/list', { params: this.periodParams() })
        .then(res => { this.list = res.data || [] })
        .finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.profit-explanation { margin: -4px 0 12px; color: #909399; font-size: 12px; }
::v-deep .profit-total-row { font-weight: 600; background: #f5f7fa; }
</style>
